import React from 'react';
import ReactDOM from 'react-dom';
import OverallScore from './OverallScore';
import {hideCtaElement, changeCtaElementText} from './../../shared/Membership';

export default function() {
    const overallScoreContainers = document.getElementsByClassName('overall-score');

    for(let i = 0; i < overallScoreContainers.length; i++) {
        let overallScoreContainer = overallScoreContainers[i];
        let score = +overallScoreContainer.getAttribute('data-score') || 0;
        let isOnlyBlob = (overallScoreContainer.getAttribute('data-is-only-blob') === 'true');
        let minScore = +overallScoreContainer.getAttribute('data-min-score') || 0;
        let maxScore = +overallScoreContainer.getAttribute('data-max-score') || 0;
        let scoreDisplayName = overallScoreContainer.getAttribute('data-score-display-name') || '';
        let type = overallScoreContainer.getAttribute('data-score-type') || '';
        let isOneModelRated = (overallScoreContainer.getAttribute('data-is-one-model-rated') === 'true');

        ReactDOM.render(
            <OverallScore
                score={score}
                isOnlyBlob={isOnlyBlob}
                minScore={minScore}
                maxScore={maxScore}
                scoreDisplayName={scoreDisplayName}
                type={type}
                isOneModelRated={isOneModelRated}
            />, overallScoreContainer);
    }

};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/OverallScore/index.jsx